/// <amd-module name="Test/common-util/TCMPerfScenarios" />
import { Constants } from "Test/common-util/Common";

export const Area = "TestManagement";

// Scenarios
export const TestResultsInBuildTimeLine_SummaryDetails = "VSO.TFS.TRA.TestResultInBuildTimeLine_SummaryDetails";
export const TestPivotInBuildLoad = Constants.buildTestPivotProviderId;
export const TestPivotInReleaseLoad = Constants.releaseTestPivotProviderId;
export const TestSummaryLoaded = "test-summary-loaded";
export const TestResultDetailsViewLoaded = "VSO.TFS.TRA.TestResultsInTestTab.NavigateResultDetails";
